import {SET_COORDS} from "./types";

export const setCoords = (lat, lng) => {
    return{
        type: SET_COORDS,
        payload: {
            lat,
            lng,
        }
    }
}